import { render, staticRenderFns } from "./Powerups.vue?vue&type=template&id=79437992&scoped=true&"
import script from "./Powerups.vue?vue&type=script&lang=js&"
export * from "./Powerups.vue?vue&type=script&lang=js&"
import style0 from "./Powerups.vue?vue&type=style&index=0&id=79437992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79437992",
  null
  
)

export default component.exports